@if (!loading) {
  <div class="select">
    <select (change)="addPermitTypeFilter($event)" [value]="selectedPermitTypeId">
      <option value="0" selected>All Permit Types</option>
      @for (permitType of permitTypes; track permitType) {
        <option [value]="permitType.Id">
          {{permitType.Name}}
        </option>
      }
    </select>
  </div>
}
@if (loading) {
  <div class="select">
    <select disabled>
      <option>Loading Permit Types...</option>
    </select>
  </div>
}

